/**
 * @file google mapのリンク先へ飛ぶ
 */
'use strict'

/**
 * @classname JumpGoogleMap
 * @classdesc google mapのリンク先へ飛ぶ
 */
export default class JumpGoogleMap {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {object} controller - controllerオブジェクト
	 */
	constructor($e, controller) {
		console.log('JumpGoogleMap.constructor')
		this._$e = $e
		this._$googleMapLinkInput = $('.input-text-google-map-link')
		this._$e.on('click', (e) => this.onClick(e))
	}

	/**
	 * ファイル変更のコールバック
	 *
	 * @memberof JumpGoogleMap
	 * @return {undefined}
	 */
	onClick() {
		console.log('JumpGoogleMap.onClick')
		const link = this._$googleMapLinkInput.val()
		window.open(link, '_blank')
	}
}
